import PropTypes from 'prop-types';

export default PropTypes.shape({
  name: PropTypes.string.isRequired,
  young: PropTypes.bool,
  active: PropTypes.bool,
  depth: PropTypes.any,
  numberOfEmptyReceives: PropTypes.number
});


// WEBPACK FOOTER //
// ./src/shapes/comm-instance.js